export function normalizeProductFilters(product) {
  let res = {};
  res.category = product?.terminalFilter?.category || [];

  return res;
}

export function normalizeProductName(product) {
  const res = product?.name || null;
  return res;
}

export function normalizeProductOffering(product) {}
